import DOMPurify from 'dompurify';
import marked from '../../utils/markdownConfig';

const MATH_PLACEHOLDER_PREFIX = '@@EINSTEINMATH';
const MATH_PLACEHOLDER_SUFFIX = '@@';

export const hasLatexDelimiters = (text: string): boolean =>
  /\$\$|\\\[|\\\(|\\begin\{|\$(?:\\.|[^$\n])+\$/.test(text);

const stashMathSections = (s: string): { text: string; mathSections: string[] } => {
  const mathSections: string[] = [];
  const stash = (match: string) => {
    const placeholder = `${MATH_PLACEHOLDER_PREFIX}${mathSections.length}${MATH_PLACEHOLDER_SUFFIX}`;
    mathSections.push(match);
    return placeholder;
  };

  let text = s;
  text = text.replace(/\$\$[\s\S]+?\$\$/g, stash);
  text = text.replace(/\\\[[\s\S]+?\\\]/g, stash);
  text = text.replace(/\\begin\{([a-zA-Z*]+)\}[\s\S]+?\\end\{\1\}/g, stash);
  text = text.replace(/\\\([\s\S]+?\\\)/g, stash);
  text = text.replace(/\$((?:\\.|[^$\n])+?)\$/g, (full, inner: string) => {
    // Keep currency like $50; treat as math when it looks like TeX.
    if (!/[\\^_{}]|[a-zA-Z]/.test(inner)) return full;
    return stash(full);
  });

  return { text, mathSections };
};

export const formatChatMarkdown = (s: string): string => {
  try {
    if (!s) return '';

    // Placeholders must not use `__...__` — markdown treats that as <strong>.
    const { text: textWithPlaceholders, mathSections } = stashMathSections(s);

    if (!marked || !marked.parse) {
      console.warn('[ChatWidget] marked library not available, returning raw text');
      return s;
    }

    const html = marked.parse(textWithPlaceholders, { breaks: true, gfm: true }) as string;
    const sanitized = DOMPurify.sanitize(html, {
      ALLOWED_TAGS: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'br', 'strong', 'b', 'em', 'i', 'ul', 'ol', 'li', 'code', 'pre', 'blockquote', 'a', 'hr', 'table', 'thead', 'tbody', 'tr', 'th', 'td', 'sub', 'sup', 'span'],
      ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
    });

    let restored = sanitized;
    mathSections.forEach((content, i) => {
      const placeholder = `${MATH_PLACEHOLDER_PREFIX}${i}${MATH_PLACEHOLDER_SUFFIX}`;
      // split/join avoids String.replace turning LaTeX `$$` into `$`.
      restored = restored.split(placeholder).join(content);
    });

    restored = restored.replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');
    return restored;
  } catch (err) {
    console.error('[ChatWidget] formatChatMarkdown error:', err);
    return s;
  }
};
